import React from 'react';
import {
  Container,
  BlocWrapper,
} from 'containers/MRHDetailsPage/ServicesBlock/styles';
import ServicesBloc from 'containers/MRhDashboard/services';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const ServicesBlock = () => {
  return (
    <GaClickHOC
      category={EVENT_CATEGORIES.MRH_DETAILS}
      label="	
    Mes services_Contacter mon agent "
    >
      <BlocWrapper height="135px">
        <Container padding={3}>
          <ServicesBloc position={12} />
        </Container>
      </BlocWrapper>
    </GaClickHOC>
  );
};
export default ServicesBlock;
